"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WKWebViewController = exports.CallTypeEnum = void 0;
var tslib_1 = require("tslib");
var registerGlobalValue_1 = require("./registerGlobalValue");
var CallTypeEnum;
(function (CallTypeEnum) {
    CallTypeEnum["callAndBackfeed"] = "callAndBack";
    CallTypeEnum["callAndListen"] = "callAndListen";
})(CallTypeEnum = exports.CallTypeEnum || (exports.CallTypeEnum = {}));
;
var $window = window;
/**
 *
 * 将原本 JSBridgeApp 中的逻辑均聚合至此 Controller 实现，
 * 目的是规避太多的引用对象被暴露（防止因引用对象被'篡改'造成未知异常）。
 *
 */
var WKWebViewController = /** @class */ (function () {
    function WKWebViewController() {
        this.checkBridgeReady();
    }
    WKWebViewController.prototype.checkBridgeReady = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 6000; }
        if (this.worker)
            return true;
        var start = performance.now();
        return new Promise(function (resolve, reject) {
            var check = function () {
                if (_this.worker)
                    return resolve(true);
                if ($window.webkit && $window.webkit.messageHandlers && $window.webkit.messageHandlers.realsee) {
                    var worker_1 = $window.webkit.messageHandlers.realsee;
                    worker_1.postMessage(JSON.stringify({
                        type: 'getStaticData',
                        param: JSON.stringify({
                            functionName: (0, registerGlobalValue_1.registerGlobalValue)('HYBRID_BRIDGE_NAME', function (data) {
                                _this.deviceInfo = JSON.parse(data);
                                _this.worker = worker_1;
                                return resolve(true);
                            })
                        })
                    }));
                    return;
                }
                if (performance.now() - start > (timeout || 6000)) {
                    console.warn('HybridBridge 初始化超时~');
                    return reject(new Error('HybridBridge 初始化超时~'));
                }
                // 逐帧监测
                requestAnimationFrame(check);
            };
            // 开启监测
            check();
        });
    };
    WKWebViewController.prototype.checkReady = function (timeout) {
        if (timeout === void 0) { timeout = 6000; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res, _a, _b, error_1;
            return (0, tslib_1.__generator)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        res = [null, null];
                        if (this.worker) {
                            res[0] = true;
                            return [2 /*return*/, res];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        _a = res;
                        _b = 0;
                        return [4 /*yield*/, this.checkBridgeReady(timeout)];
                    case 2:
                        _a[_b] = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        res[0] = false;
                        res[1] = error_1;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, res];
                }
            });
        });
    };
    Object.defineProperty(WKWebViewController.prototype, "ready", {
        get: function () {
            return !!this.worker;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WKWebViewController.prototype, "scheme", {
        get: function () {
            var _a;
            return ((_a = this.deviceInfo) === null || _a === void 0 ? void 0 : _a.scheme) || '';
        },
        enumerable: false,
        configurable: true
    });
    WKWebViewController.prototype.createSchemeLink = function (schemeUrl) {
        if (schemeUrl.startsWith(this.scheme)) {
            return schemeUrl;
        }
        return this.scheme + '://' + schemeUrl;
    };
    WKWebViewController.prototype.callAndBackfeed = function (scheme) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res, _a, ready, readyError;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        res = [false, null];
                        return [4 /*yield*/, this.checkReady()];
                    case 1:
                        _a = _b.sent(), ready = _a[0], readyError = _a[1];
                        if (!ready) {
                            res[0] = false;
                            res[1] = readyError;
                            return [2 /*return*/, res];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                                var actionUrl, msg;
                                return (0, tslib_1.__generator)(this, function (_a) {
                                    actionUrl = this.createSchemeLink(scheme);
                                    msg = JSON.stringify({
                                        actionUrl: actionUrl,
                                        functionName: (0, registerGlobalValue_1.registerGlobalValue)(this.createSchemeLink(scheme), function (data) {
                                            var d = JSON.parse(data);
                                            res[0] = (function () {
                                                if (d === 1)
                                                    return true;
                                                if (d === 0)
                                                    return false;
                                                return d;
                                            })();
                                            resolve(res);
                                        })
                                    });
                                    this.worker.postMessage(JSON.stringify({
                                        type: 'callAndBackfeed',
                                        param: msg
                                    }));
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    WKWebViewController.prototype.callAndListen = function (scheme, callback) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var res, _a, ready, readyError;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        res = [false, null];
                        return [4 /*yield*/, this.checkReady()];
                    case 1:
                        _a = _b.sent(), ready = _a[0], readyError = _a[1];
                        if (!ready) {
                            res[0] = false;
                            res[1] = readyError;
                            return [2 /*return*/, res];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                                var actionUrl, _callback, msg;
                                return (0, tslib_1.__generator)(this, function (_a) {
                                    actionUrl = this.createSchemeLink(scheme);
                                    _callback = function (data) {
                                        var d = JSON.parse(data);
                                        var callbackParam = (function () {
                                            if (d === 1)
                                                return true;
                                            if (d === 0)
                                                return false;
                                            return d;
                                        })();
                                        callback(callbackParam);
                                        res[0] = function () {
                                            // 清理掉当前的回调引用
                                            var callbacks = registerGlobalValue_1.cache[actionUrl];
                                            if (!callbacks)
                                                return;
                                            var idx = callbacks.queue.findIndex(function (func) { return func.callback === _callback; });
                                            if (idx !== -1) {
                                                callbacks.queue.splice(idx, 1);
                                            }
                                        };
                                        resolve(res);
                                    };
                                    msg = JSON.stringify({
                                        actionUrl: actionUrl,
                                        functionName: (0, registerGlobalValue_1.registerGlobalValue)(actionUrl, _callback, false)
                                    });
                                    this.worker.postMessage(JSON.stringify({
                                        type: 'callAndListen',
                                        param: msg,
                                    }));
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return WKWebViewController;
}());
exports.WKWebViewController = WKWebViewController;
//# sourceMappingURL=WKWebViewController.js.map